<template>
  <v-dialog v-model="dialog" max-width="420" persistent>
    <v-card>
      <v-card-title class="headline">Copy Departure to Date</v-card-title>
      <v-card-text>
        <div class="mb-2 text--secondary">
          Copying <strong>{{ source && source.name }}</strong> ({{
            source && source.startDate | formatDate
          }}). Pick a new start date — return date shifts by the same duration.
        </div>
        <date-picker
          v-model="newDate"
          custom-label="New Start Date"
          outlined
          :allowed-dates-fn="masterDayAndRangeFn"
          :error-messages="errors"
        ></date-picker>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onCancel">Cancel</v-btn>
        <v-btn
          color="primary"
          :loading="saving"
          :disabled="!newDate"
          @click="onConfirm"
          >Copy</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import DatePicker from "../../shared/DatePicker";
import { COPY_OPEN_GROUP_DEPARTURE_TO_DATE } from "../departure-gql";

export default {
  name: "OpenGroupDepartureCopyDialog",

  components: { DatePicker },

  props: {
    value: { type: Boolean, default: false },
    source: { type: Object, default: null },
    masterValidFrom: { type: String, default: null },
    masterValidTo: { type: String, default: null },
    masterDaysOfWeek: { type: Array, default: () => [] },
  },

  data() {
    return {
      newDate: "",
      saving: false,
      errors: [],
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },

  watch: {
    value(open) {
      if (open) {
        this.newDate = "";
        this.errors = [];
      }
    },
  },

  methods: {
    masterDayAndRangeFn(val) {
      if (this.masterValidFrom && this.masterValidTo) {
        const from = moment(this.masterValidFrom);
        const to = moment(this.masterValidTo);
        if (
          from.isValid() &&
          to.isValid() &&
          !moment(val).isBetween(from, to, "days", "[]")
        ) {
          return false;
        }
      }
      const allowed = this.masterDaysOfWeek || [];
      if (allowed.length === 0) return true;
      const wday = String(moment(val).day());
      return allowed.includes(wday);
    },
    onCancel() {
      this.dialog = false;
    },
    onConfirm() {
      if (!this.source || !this.newDate) return;
      this.saving = true;
      this.errors = [];
      this.$apollo
        .mutate({
          mutation: COPY_OPEN_GROUP_DEPARTURE_TO_DATE,
          variables: { id: this.source.id, newStartDate: this.newDate },
        })
        .then(({ data }) => {
          this.saving = false;
          this.dialog = false;
          this.$emit("copied", data.copyOpenGroupDepartureToDate);
        })
        .catch((err) => {
          this.saving = false;
          this.errors = err.graphQLErrors
            ? err.graphQLErrors.map((e) => e.message)
            : [err.message];
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/open-groups/builder/OpenGroupDepartureCopyDialog.vue